module.exports = __webpack_public_path__ + "img/Space-Invaders-Emoji.1897ecff.png";